import { useMutation } from 'react-query';

import { refreshProgramAnalysisData as mutationFn } from 'api/endPoints/refreshProgramAnalysisData';

export const useMutationRefreshProgramAnalysisData = () => {
    return useMutation<any, QueryError, RefreshProgramAnalysisData>({
        mutationFn,
    });
};

interface RefreshProgramAnalysisData {
    projectIDs?: number[];
    contractId?: number;
}
